import { motion } from "framer-motion";

export const Sidebar = ({ templates, selectedId, onSelect }) => {
  const categories = [...new Set(templates.map((t) => t.category))];
  let idx = 0;
  return (
    <aside data-testid="template-sidebar" className="w-72 shrink-0 border-r border-border overflow-y-auto h-full">
      <div className="p-5">
        {categories.map((cat) => (
          <div key={cat} className="mb-6">
            <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-accent mb-2 px-2">{cat}</p>
            {templates
              .filter((t) => t.category === cat)
              .map((t) => (
                <motion.button
                  key={t.id}
                  initial={{ opacity: 0, x: -12 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.35, delay: 0.05 * idx++, ease: "easeOut" }}
                  data-testid={`template-item-${t.id}`}
                  onClick={() => onSelect(t.id)}
                  className={`tpl-item w-full text-left rounded-lg px-3 py-2.5 mb-1 border ${
                    selectedId === t.id
                      ? "bg-secondary border-accent/40"
                      : "border-transparent hover:bg-secondary/60"
                  }`}
                >
                  <p className="text-sm font-semibold text-foreground">{t.name}</p>
                  <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{t.description}</p>
                </motion.button>
              ))}
          </div>
        ))}
      </div>
    </aside>
  );
};
